import { Link } from 'gatsby';
import React from 'react';

const Pagination = ({
  previousPagePath,
  nextPagePath,
  humanPageNumber,
  numberOfPages,
}) => {
  return (
    <nav
      className="my-3 pagination is-centered is-rounded"
      role="navigation"
      aria-label="pagination"
    >
      <Link
        disabled={!previousPagePath}
        className="pagination-previous"
        to={`${previousPagePath}/`}
      >
        Previous
      </Link>
      <Link
        className="pagination-next"
        to={`${nextPagePath}/`}
        disabled={!nextPagePath}
      >
        Next page
      </Link>
      <ul className="pagination-list">
        {humanPageNumber !== 1 && (
          <>
            <li>
              <span
                disabled
                className="pagination-link"
                aria-label={`Page 1`}
                aria-current="page"
              >
                1
              </span>
            </li>

            <li>
              <span className="pagination-ellipsis">&hellip;</span>
            </li>
          </>
        )}
        <li>
          <span
            className="pagination-link is-current"
            aria-label={`Page ${humanPageNumber}`}
            aria-current="page"
          >
            {humanPageNumber}
          </span>
        </li>
        {numberOfPages !== humanPageNumber && (
          <>
            <li>
              <span className="pagination-ellipsis">&hellip;</span>
            </li>
            <li>
              <span
                disabled
                className="pagination-link"
                aria-label={`Page ${numberOfPages}`}
                aria-current="page"
              >
                {numberOfPages}
              </span>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
